// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { XNGAGE_CUSTOM_WIDGET } from "@sc/XDL/constants";
import { xMask } from "@sc/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    contactNumber = "contactNumber",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.contactNumber]: string;
    };
}

type Props = OwnProps;

export interface ContactNumberStyles {
    link?: LinkPresentationProps;
}

export const contactNumberStyles: ContactNumberStyles = {
    link: {
        typographyProps: {
            weight: "bold",
            lineHeight: "22px",
            size: 14,
            css: css`
                white-space: nowrap;
            `,
        },
        css: css`
            padding-left: 16px;
        `,
    },
};

const ContactNumber: FC<Props> = ({ id, fields }) => {
    const styles = contactNumberStyles;
    return (
        <>
            {fields.contactNumber && (
                <Link aria-label="Contact Number" className="contact-number" href={`tel:${fields.contactNumber}`} {...styles.link}>
                    {xMask.phoneNumber(fields.contactNumber)}
                </Link>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ContactNumber,
    definition: {
        displayName: "Contact Number",
        group: XNGAGE_CUSTOM_WIDGET,
        fieldDefinitions: [
            {
                name: fields.contactNumber,
                displayName: "Contact Number",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
